import React, { ImgHTMLAttributes } from 'react';

type Props = ImgHTMLAttributes<SVGElement>;

const LightMode: React.FC<Props> = ({ className }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path
      d='M12.459 3C12.459 2.58579 12.1232 2.25 11.709 2.25C11.2948 2.25 10.959 2.58579 10.959 3V4.58333C10.959 4.99755 11.2948 5.33333 11.709 5.33333C12.1232 5.33333 12.459 4.99755 12.459 4.58333V3Z'
      fill='currentColor'
    />
    <path
      d='M18.3986 6.07916C18.6915 5.78626 18.6915 5.31139 18.3986 5.0185C18.1057 4.7256 17.6309 4.7256 17.338 5.0185L16.2138 6.14266C15.9209 6.43556 15.9209 6.91043 16.2138 7.20333C16.5067 7.49622 16.9816 7.49622 17.2745 7.20333L18.3986 6.07916Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.25 11.9583C7.25 9.35799 9.35799 7.25 11.9583 7.25C14.5587 7.25 16.6667 9.35799 16.6667 11.9583C16.6667 14.5587 14.5587 16.6667 11.9583 16.6667C9.35799 16.6667 7.25 14.5587 7.25 11.9583ZM11.9583 8.75C10.1864 8.75 8.75 10.1864 8.75 11.9583C8.75 13.7302 10.1864 15.1667 11.9583 15.1667C13.7302 15.1667 15.1667 13.7302 15.1667 11.9583C15.1667 10.1864 13.7302 8.75 11.9583 8.75Z'
      fill='currentColor'
    />
    <path
      d='M11.709 18.083C12.1232 18.083 12.459 18.4188 12.459 18.833V20.4163C12.459 20.8306 12.1232 21.1663 11.709 21.1663C11.2948 21.1663 10.959 20.8306 10.959 20.4163V18.833C10.959 18.4188 11.2948 18.083 11.709 18.083Z'
      fill='currentColor'
    />
    <path
      d='M17.2745 16.2128C16.9816 15.9199 16.5067 15.9199 16.2138 16.2128C15.9209 16.5057 15.9209 16.9806 16.2138 17.2735L17.338 18.3977C17.6309 18.6906 18.1057 18.6906 18.3986 18.3977C18.6915 18.1048 18.6915 17.6299 18.3986 17.337L17.2745 16.2128Z'
      fill='currentColor'
    />
    <path
      d='M7.20333 16.2128C7.49622 16.5057 7.49622 16.9806 7.20333 17.2735L6.07916 18.3977C5.78626 18.6906 5.31139 18.6906 5.0185 18.3977C4.7256 18.1048 4.7256 17.6299 5.0185 17.337L6.14266 16.2128C6.43556 15.9199 6.91043 15.9199 7.20333 16.2128Z'
      fill='currentColor'
    />
    <path
      d='M18.834 10.958C18.4198 10.958 18.084 11.2938 18.084 11.708C18.084 12.1222 18.4198 12.458 18.834 12.458H20.4173C20.8315 12.458 21.1673 12.1222 21.1673 11.708C21.1673 11.2938 20.8315 10.958 20.4173 10.958H18.834Z'
      fill='currentColor'
    />
    <path
      d='M2.25 11.708C2.25 11.2938 2.58579 10.958 3 10.958H4.58333C4.99755 10.958 5.33333 11.2938 5.33333 11.708C5.33333 12.1222 4.99755 12.458 4.58333 12.458H3C2.58579 12.458 2.25 12.1222 2.25 11.708Z'
      fill='currentColor'
    />
    <path
      d='M5.0185 5.0185C5.31139 4.7256 5.78626 4.7256 6.07916 5.0185L7.20332 6.14266C7.49622 6.43556 7.49622 6.91043 7.20332 7.20332C6.91043 7.49622 6.43556 7.49622 6.14266 7.20332L5.0185 6.07916C4.7256 5.78626 4.7256 5.31139 5.0185 5.0185Z'
      fill='currentColor'
    />
  </svg>
);

export { LightMode };
